import { GridItem } from '@chakra-ui/react';
import { ListRow } from 'components/molecules/ListRow';
import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { DisplayStatusBadge } from 'page/NotificationPage/components/DisplayStatusBagde';
import { FC } from 'react';
import { DisplayStatus } from 'types/notification';

type Props = {
  /** お知らせのタイトル */
  title: string;
  /** お知らせの本文 */
  message: string;
  /** 重要度の表示名 */
  levelName: string;
  /** 表示ステータス */
  displayStatus: DisplayStatus;
  /** 表示開始日時 */
  startsAt: string;
  /** 表示終了日時 */
  endsAt: string;
  /** 行クリックイベントのハンドラ */
  handleClickNotification: () => void;
};

export const NotificationListItem: FC<Props> = ({
  title,
  message,
  levelName,
  displayStatus,
  startsAt,
  endsAt,
  handleClickNotification,
}) => (
  <ListRow
    onClick={handleClickNotification}
    templateColumns="3fr 4fr 1fr 1fr 2fr 2fr"
  >
    <GridItem>
      <TextWithTooltip
        text={title}
        textMaxWidth="200px"
        visibleTooltip
        tooltipMaxWidth="400px"
      />
    </GridItem>
    <GridItem>
      <TextWithTooltip
        text={message}
        textMaxWidth="300px"
        visibleTooltip
        tooltipMaxWidth="600px"
      />
    </GridItem>
    <GridItem>
      <TextWithTooltip text={levelName} />
    </GridItem>
    <GridItem>
      <DisplayStatusBadge displayStatus={displayStatus} />
    </GridItem>
    <GridItem>
      <TextWithTooltip text={startsAt} />
    </GridItem>
    <GridItem>
      <TextWithTooltip text={endsAt} />
    </GridItem>
  </ListRow>
);
